<div class="setting-page">
  <legend>Quality Based Routing</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit">
    <div class="qualityBasedRoutingSettings" *ngIf="qualityBasedRoutingSettings">
      <div class="settings-section">
        <div class="arm-checkbox">
        <mat-checkbox name="isQualityEnabled-checkbox" color="primary" [(ngModel)]="qualityBasedRoutingSettings.isQualityEnabled"
                      (change)="updateSlidersOptions(undefined)">Use Quality Based Routing</mat-checkbox>
        </div>
        <div class="qualityConf-container">
          <mat-slide-toggle class="quality-slider"
                            [checked]="qualityBasedRoutingSettings.qualityConf.MOS.isUsed" color="primary"
                            (change)="qualityBasedRoutingSettings.qualityConf.MOS.isUsed = $event.checked; updateSlidersOptions('mos')"
                            [disabled]="!qualityBasedRoutingSettings.isQualityEnabled">
            MOS
          </mat-slide-toggle>

          <div class="mos-container">
            <ngx-slider class="quality-thresholds"
                        [options]="mosSliderOptions"
                        [(value)]="qualityBasedRoutingSettings.qualityConf.MOS.lowerThreshold"
                        [(highValue)]="qualityBasedRoutingSettings.qualityConf.MOS.upperThreshold">
            </ngx-slider>
            <div id="mos-thresholds-ranges-labels-container" [ngClass]="(!qualityBasedRoutingSettings.isQualityEnabled || !qualityBasedRoutingSettings.qualityConf.MOS.isUsed) ? 'irrelevant':''">
              <label class="left-label"></label><label class="sign-label"></label><label class="medium-label">good</label><label class="sign-label">>=</label><label class="right-label">{{qualityBasedRoutingSettings.qualityConf.MOS.upperThreshold}}</label>
              <br/>
              <label class="left-label">{{qualityBasedRoutingSettings.qualityConf.MOS.lowerThreshold}}</label><label class="sign-label"><</label><label class="medium-label">fair</label><label class="sign-label"><</label><label class="right-value">{{qualityBasedRoutingSettings.qualityConf.MOS.upperThreshold}}</label>
              <br/>
              <label class="left-label"></label><label class="sign-label"></label><label class="medium-label">bad</label><label class="sign-label"><=</label><label class="right-label">{{qualityBasedRoutingSettings.qualityConf.MOS.lowerThreshold}}</label>
            </div>
          </div>
        </div>


        <div class="qualityConf-container">
          <mat-slide-toggle class="quality-slider"
                            [checked]="qualityBasedRoutingSettings.qualityConf.ASR.isUsed" color="primary"
                            (change)="qualityBasedRoutingSettings.qualityConf.ASR.isUsed = $event.checked; updateSlidersOptions('asr')"
                            [disabled]="!qualityBasedRoutingSettings.isQualityEnabled">
            ASR
          </mat-slide-toggle>

          <div class="asr-container">
            <ngx-slider class="quality-thresholds"
                        [options]="asrSliderOptions"
                        [(value)]="qualityBasedRoutingSettings.qualityConf.ASR.lowerThreshold"
                        [(highValue)]="qualityBasedRoutingSettings.qualityConf.ASR.upperThreshold">
            </ngx-slider>
            <div id="asr-thresholds-ranges-labels-container" [ngClass]="(!qualityBasedRoutingSettings.isQualityEnabled || !qualityBasedRoutingSettings.qualityConf.ASR.isUsed) ? 'irrelevant':''">
              <label class="left-label"></label><label class="sign-label"></label><label class="medium-label">good</label><label class="sign-label">>=</label><label class="right-label">{{qualityBasedRoutingSettings.qualityConf.ASR.upperThreshold}}%</label>
              <br/>
              <label class="left-label">{{qualityBasedRoutingSettings.qualityConf.ASR.lowerThreshold}}%</label><label class="sign-label"><</label><label class="medium-label">fair</label><label class="sign-label"><</label><label class="right-value">{{qualityBasedRoutingSettings.qualityConf.ASR.upperThreshold}}%</label>
              <br/>
              <label class="left-label"></label><label class="sign-label"></label><label class="medium-label">bad</label><label class="sign-label"><=</label><label class="right-label">{{qualityBasedRoutingSettings.qualityConf.ASR.lowerThreshold}}%</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </arm-form>
</div>
